import React from 'react';

import { WebJoint } from '@paragon/contract-library';
import { LineSegment2D } from '@paragon/geometry-library';
import { RaycastOrder, RenderOrder } from '@paragon/three-shared';

import { useAppDispatch, useAppSelector } from '../../components/hooks';
import { calculateWebJointLocation } from '../../library/profiles/profileManipulation';
import { leftClickItem } from '../../store/actions/sceneInteractionActions';
import { getSingleSelectedItemEntryOrNull } from '../../store/selectors/getSelectedItemSelector';

interface Props {
  readonly segmentGeometry: LineSegment2D;
  readonly webJoint: WebJoint;
  readonly jointType: 'fixed' | 'floating' | 'feature';
  readonly registerForRaycasting: boolean;
}

export function WebJointVisual({ jointType, registerForRaycasting, segmentGeometry, webJoint }: Props) {
  const dispatch = useAppDispatch();

  const selectedEntry = useAppSelector(getSingleSelectedItemEntryOrNull);
  const selected = selectedEntry?.type === 'webJoint' && selectedEntry.item.guid === webJoint.guid;

  const position = calculateWebJointLocation(segmentGeometry, webJoint);

  return (
    <mesh
      onClick={
        registerForRaycasting
          ? (event) => dispatch(leftClickItem(event, { item: webJoint, type: 'webJoint' }))
          : undefined
      }
      userData-raycastOrder={RaycastOrder.ProfileWebJointVisual}
      renderOrder={RenderOrder.WebJointVisual}
      position={position.to3D().toArray()}
    >
      <sphereGeometry args={[1, 8, 8]} />
      <meshBasicMaterial
        color={selected ? 0xff0022 : jointType === 'fixed' ? 0x42e558 : jointType === 'floating' ? 0xffffff : 0xee10ee}
        transparent
        depthTest={false}
        depthWrite={false}
        opacity={1}
      />
    </mesh>
  );
}
